import { Component, OnInit, VERSION } from '@angular/core';
import { UntypedFormBuilder} from '@angular/forms';
import { RequestsService } from 'src/app/core/services/http/requests.service';
import { Urls } from 'src/app/lib/urls';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from 'ngx-toastr';
import { IAccount } from 'src/app/core/model/server/vo/IAccount.interface';
import { IAttachedBankCard } from 'src/app/core/model/server/vo/IAttachedBankCard.interface';

interface AccountDetailsResult {
  result: IAccount;
}
@Component({
  selector: 'app-accounts-information',
  templateUrl: './accounts-information.component.html',
  styleUrls: ['./accounts-information.component.scss']
})
export class AccountsInformationComponent implements OnInit {
  uid: any;
  firstName: any;
  lastName: any;
  middleName: any;
  userName: any;
  email: any;
  createDate: any;
  referrerNumber: any;
  referralSource: string | null = null;
  cardNo: any;
  cardHolderName: any;
  cardEmail: any;
  time: any;
  abcLists: IAttachedBankCard[] = [];
  referrerName: string | null = null;

  // tiertype
  tierType_text: any;
  tierId: any;

  // status
  status_text: any;
  status: any;

  // emailverified
  emailVerified_text: any;
  emailVerified: any;

  // null with default
  name = 'Angular ' + VERSION.major;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb : UntypedFormBuilder,
    private request: RequestsService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit(): void {
    this.uid = this.route.snapshot.paramMap.get('id');
    this.get_user();
  }

  get_user(){
    this.request.get(Urls.userAccount + '/' + this.uid, ).then((response: AccountDetailsResult) => {
      this.firstName = response.result.firstName;
      this.lastName = response.result.lastName;
      this.middleName = response.result.middleName;
      this.userName = response.result.userName;
      this.email = response.result.email;
      this.createDate = response.result.createDate;
      this.referrerNumber = response.result.referrerNumber;
      this.referralSource = response.result.referralSource;
      this.referrerName = response.result.referrerName;
      this.abcLists = response.result.attachedBankCards ?? [];

      // tier
      this.tierId = response.result.tierId;
      if (response.result.tierId === 1){
        this.tierType_text = 'Default';
      }else if (response.result.tierId === 4) {
        this.tierType_text = ' Full';
      }else if (response.result.tierId === 5) {
        this.tierType_text = 'Internal';
      }else if (response.result.tierId === 6) {
        this.tierType_text = 'Business';
      }else if (response.result.tierId === 7) {
        this.tierType_text = 'MegaBiz';
      }else {
        this.tierType_text = 'MegaOne';
      }
      // status
      this.status = response.result.status;
      if (response.result.status === 0){
        this.status_text = 'Yes';
      }else {
        this.status_text = 'No';
      }
      // emailVerified
      this.emailVerified = response.result.emailVerified;
      if (response.result.emailVerified === 0){
        this.emailVerified_text = 'Yes';
      }else {
        this.emailVerified_text = 'No';
      }
      // referrerNum
      this.referrerNumber = response.result.referrerNumber;
    })
  }
}
